import './NewTournamentModal.scss';
import { observer } from 'mobx-react-lite';
import { tournamentStore } from '../../../../../platform/stores';
import { useEffect, useState } from 'react';
import { TournamentType } from '../../../../../platform/enums';

export const NewTournamentModal = observer(() => {
  const [isClosing, setIsClosing] = useState(false);
  const [dontShowAgain, setDontShowAgain] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  const tournament = tournamentStore.activeTournament;

  useEffect(() => {
    if (tournament) {
      // Check if user has chosen to not show this tournament notification
      const hiddenTournaments = JSON.parse(localStorage.getItem('hiddenTournamentNotifications') || '[]');
      const shouldShow = !hiddenTournaments.includes(tournament.id);

      if (shouldShow) {
        setIsVisible(true);
      }
    }
  }, [tournament]);

  if (!tournament || !isVisible) {
    return null;
  }

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsClosing(false);
      setIsVisible(false);

      // Save to localStorage if user chose "don't show again"
      if (dontShowAgain) {
        const hiddenTournaments = JSON.parse(localStorage.getItem('hiddenTournamentNotifications') || '[]');
        if (!hiddenTournaments.includes(tournament.id)) {
          hiddenTournaments.push(tournament.id);
          localStorage.setItem('hiddenTournamentNotifications', JSON.stringify(hiddenTournaments));
        }
      }
    }, 300);
  };

  const handleJoin = () => {
    // Handle tournament join logic here
    console.log('Joining tournament:', tournament.id);
    tournamentStore.setMainModalIsOpened(true);
    handleClose();
  };

  const handleBuyTicket = () => {
    // Handle buy ticket logic here
    console.log('Buying ticket for tournament:', tournament.id);
    handleClose();
  };

  // Determine tournament type and requirements
  const requiresMinBet = tournament.minBetAmount > 0;
  const requiresTicket = tournament.type === TournamentType.Score;

  // Get appropriate button text and action
  const getButtonConfig = () => {
    if (requiresTicket) {
      return {
        text: 'Buy Ticket',
        action: handleBuyTicket,
        description: `Minimum bet required: ${tournament.currency} ${tournament.minBetAmount}`
      };
    } else if (requiresMinBet) {
      return {
        text: 'Join Tournament',
        action: handleJoin,
        description: `Place bets of ${tournament.currency} ${tournament.minBetAmount} or more to automatically join`
      };
    } else {
      return {
        text: 'Join Tournament',
        action: handleJoin,
        description: 'You will automatically join when you start playing'
      };
    }
  };

  const buttonConfig = getButtonConfig();

  return (
    <div className={`new-tournament-modal-overlay ${isClosing ? 'closing' : ''}`}>
      <div className="new-tournament-modal">
        {/* Close button */}
        <div className="close-btn" onClick={handleClose}>×</div>

        {/* Tournament Banner */}
        <div className="tournament-banner" style={{ backgroundImage: `url('${tournament.banner}')` }}>
          <div className="banner-overlay">
            <div className="new-badge">{tournament.name}</div>
          </div>
        </div>

        {/* Content */}
        <div className="modal-content">
          {/* Tournament Name & Theme */}
          {/*<div className="tournament-info">*/}
          {/*  <h2 className="tournament-name">{tournament.name}</h2>*/}
          {/*</div>*/}

          {/* Key Rewards */}
          <div className="rewards-section">
            <div className="reward-item">
              <div className="reward-icon">🏆</div>
              <div className="reward-text">
                <div className="reward-title">Win up to</div>
                <div
                  className="reward-amount">{tournament.currency} {tournament.prizeBreakDowns[0].prize.toLocaleString()}</div>
              </div>
            </div>

            {tournament.entryFee
              ?
              <div className="reward-item">
                <div className="reward-icon">💰</div>
                <div className="reward-text">
                  <div className="reward-title">Entry Fee</div>
                  <div className="reward-amount">{tournament.currency} {tournament.entryFee}</div>
                </div>
              </div>
              :
              <></>
            }

            {tournament.minPlayerCount
              ?
              <div className="reward-item">
                <div className="reward-icon">👥</div>
                <div className="reward-text">
                  <div className="reward-title">Min Players</div>
                  <div className="reward-amount">{tournament.minPlayerCount}</div>
                </div>
              </div>
              :
              <></>
            }

            {requiresMinBet && (
              <div className="reward-item">
                <div className="reward-icon">🎯</div>
                <div className="reward-text">
                  <div className="reward-title">Min Bet Required</div>
                  <div className="reward-amount">{tournament.currency} {tournament.minBetAmount}</div>
                </div>
              </div>
            )}
          </div>

          {/* Tournament Type Info */}
          <div className="tournament-type-info">
            {/*<div className="type-badge">*/}
            {/*  {isScoreTournament ? 'Score Tournament' : 'Automatic Tournament'}*/}
            {/*</div>*/}
            <p className="type-description">{buttonConfig.description}</p>
          </div>

          {/* Call-to-Action Buttons */}
          <div className="cta-section">
            <button className="cta-button primary" onClick={buttonConfig.action}>
              {buttonConfig.text}
            </button>
          </div>

          {/* Don't Show Again Option */}
          <div className="dont-show-again">
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={dontShowAgain}
                onChange={(e) => setDontShowAgain(e.target.checked)}
              />
              <span className="checkmark"></span>
              Don't show this notification again
            </label>
          </div>

          {/* Additional Info */}
          <div className="additional-info">
            <p>Don't miss out on this exciting tournament! Join now and compete for amazing prizes.</p>
          </div>
        </div>
      </div>
    </div>
  );
});